<template>
  <div>
    <van-nav-bar
      title=""
      :border="false"
    ><template slot="title">
      <strong>二维码注册</strong>
    </template>
    <template #left>
      <span class="iconfont icon-houtui fs-24 fw-700" @click="$router.back()"></span>
    </template>
    </van-nav-bar>
    <div class="main">
      <div id="box" class="box">
        <vue-qr ref="qr" :text="$route.query.url" :size="250" :margin="5" style="display: none;"/>
        <img :src="shareImg" style="width: 80%;">
        <canvas ref="canvas" style="display: none;"></canvas>
      </div>
      <div v-show="isPlus" class="flex justify-center pl-15 pr-15 mb-10" @click="saveImg"><van-button color="#169bd5" size="large" round>保存本地</van-button></div>
      <div v-show="isPlus" class="flex justify-center pl-15 pr-15 mb-10" @click="share"><van-button color="#169bd5" size="large" round>发送给好友</van-button></div>
      <div class="flex justify-center pl-15 pr-15 mb-10"><van-button color="#169bd5" size="large" to="/agent/generate-agent" round>再次创建</van-button></div>
      <div class="flex justify-center pl-15 pr-15"><van-button color="#169bd5" size="large" to="/me" round>返回个人中心</van-button></div>
    </div>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
import { mapState } from 'vuex'
import GenerateImg from './mixin/generate-img.js'
export default {
  name: 'GenerateResult',
  mixins: [GenerateImg],
  components: { vueQr },
  data() {
    return {
      loading: false,
      qrImg: '', // 二维码图片
      shareImg: '' // 分享的图片
    }
  },
  computed: {
    ...mapState(['isPlus'])
  },
  mounted() {
    this.qrImg = document.getElementById('box').querySelector('img')
    this.initCanvas()
  }
}
</script>

<style lang="scss" scoped>
.mobile{
  font-weight: 700;
  font-size: 16px;
  color: #fff;
  padding: 5px 10px;
  background-color: #169bd5;
}
.box{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  margin: 20px auto;
  padding: 15px;
  box-shadow: 0 0 5px 0 #999;
  border-radius: 8px;
}
</style>
